<div class="page">

    <div class="page-header">

        <h2>My Hospitals</h2>

        <p>Your connected healthcare providers</p>

    </div>

    <div class="hospital-card" *ngFor="let hospital of hospitals" (click)="openHospital(hospital)">

        <div class="hospital-image">

            <img [src]="hospital.image" alt="Hospital">

        </div>

        <div class="hospital-details">

            <h3>{{ hospital.name }}</h3>

            <div class="doctor">

                <i class="fa-solid fa-user-doctor"></i>

                {{ hospital.doctor }}

            </div>

            <div class="footer">

                <span>

                    <i class="fa-solid fa-location-dot"></i>

                {{ hospital.city }}

                </span>

                <i class="fa-solid fa-chevron-right arrow"></i>

            </div>

        </div>

    </div>

</div>